export default __webpack_public_path__ + "static/SuisseWorks-Regular-WebS-e6eb19aa1d0e623ae34d52da966c6a83.eot";